import { render } from "./WidgetHome.vue?vue&type=template&id=7c4e4598&scoped=true"
import script from "./WidgetHome.vue?vue&type=script&lang=js"
export * from "./WidgetHome.vue?vue&type=script&lang=js"

import "./WidgetHome.vue?vue&type=style&index=0&id=7c4e4598&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Test\\Desktop\\gthconsult-siteV2\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4e4598"]])

export default __exports__